module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJQcm9wZXJ0eSAxPSYjMjMxOyYjMTU2OyYjMTI5OyYjMjMxOyYjMTQ5OyYjMTY1OyI+DQo8Y2lyY2xlIGlkPSJFbGxpcHNlIDEzNiIgY3g9IjIiIGN5PSI2IiByPSIxIiBmaWxsPSIjOEM4QzhDIi8+DQo8Y2lyY2xlIGlkPSJFbGxpcHNlIDEzNl8yIiBjeD0iNiIgY3k9IjYiIHI9IjEiIGZpbGw9IiM4QzhDOEMiLz4NCjxjaXJjbGUgaWQ9IkVsbGlwc2UgMTM3IiBjeD0iMTAiIGN5PSI2IiByPSIxIiBmaWxsPSIjOEM4QzhDIi8+DQo8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/omit.svg
// module id = WyNU
// module chunks = 0